import { __decorate } from "tslib";
import lang from '@blade-sxp/portrait-management/lang/index';
import UploadPicture from '@blade-sxp/portrait-management/pages/components/upload-picture.vue';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { addBody, queryBodyDetail, updateBody } from '@blade-sxp/portrait-management/api/body';
import { Scale } from '@blade/common/utils/auto-scale';
import { PageQueryTypeEnum } from '@blade-sxp/portrait-management/interfaces/common';
import { bodyCreateI18nKey } from '@blade-sxp/portrait-management/routes';
import ImageUtil from '@blade-sxp/portrait-management/utils/image-util';
const Webapi = {
    addBody,
    updateBody,
    queryBodyDetail,
};
let default_1 = class default_1 extends Vue {
    formTextareaRows = 5;
    formLabelWidth = 80 * Scale + 'px';
    formInputMaxLength = 50;
    formPhoneInputMaxLength = 20;
    formNoteInputMaxLength = 50;
    defaultValueFormat = 'yyyy-MM-dd';
    permanentlt = 'PERMANENTLY';
    custom = 'CUSTOM';
    form = {
        name: '',
        libIds: [],
        gender: 'UNKNOWN',
        country: '',
        birthDay: '',
        phone: '',
        email: '',
        department: '',
        entryTime: '',
        identityId: '',
        identityType: '',
        workId: '',
        externalBizId: '',
        icCard: '',
        remark: '',
        images: [],
        validateType: this.permanentlt,
        validateEndDate: '',
    };
    rules = {
        name: [{ required: true, message: this.$t('nameInputPlaceholder'), trigger: 'blur' }],
        images: [{ type: 'array', required: true, message: this.$t('imageInputPlaceholder'), trigger: 'change' }],
        email: [
            { required: false, trigger: 'blur' },
            { type: 'email', message: this.$t('emailRulePlaceholder'), trigger: 'blur' },
        ],
    };
    portraitStatus = 'INVALIDATING'; // 失效
    submiting = false;
    loading = false;
    isDetail = false;
    pleaseSelectExpirationDate = this.$t('pleaseSelectExpirationDate');
    // 允许提交
    get allowSubmit() {
        return this.form.images.length > 0 && this.form.name.length > 0;
    }
    validateType(val) {
        if (val === this.permanentlt) {
            this.form.validateEndDate = '';
            this.pleaseSelectExpirationDate = '';
        }
        else {
            this.pleaseSelectExpirationDate = this.$t('pleaseSelectExpirationDate');
        }
    }
    created() {
        this.loading = true;
        this.$router.onReady(async () => {
            const query = this.$route.query;
            if (query.type !== PageQueryTypeEnum.CREATE) {
                await this.queryBodyDetail(+query.id);
            }
            if (query.type === PageQueryTypeEnum.DETAIL) {
                this.isDetail = true;
                this.rules = {
                    name: [],
                    images: [],
                    email: [],
                };
            }
            this.loading = false;
        });
    }
    async queryBodyDetail(id) {
        try {
            let result = await Webapi.queryBodyDetail(id);
            if (result) {
                result.images = [await ImageUtil.urlToBase64(result.image.path)];
                this.form = result;
            }
        }
        catch (error) {
            console.log('Webapi.queryBodyDetail error', error);
        }
    }
    // // 输入手机号
    // formatPhone(field: string) {
    //   (this.form[field as keyof PortraitAddRequest] as string) = this.form[field as keyof PortraitAddRequest]
    //     .toString()
    //     .replace(/[^\d-]/g, '');
    // }
    // // 输入身份证
    // formatIDCard(field: string) {
    //   (this.form[field as keyof PortraitAddRequest] as string) = this.form[field as keyof PortraitAddRequest]
    //     .toString()
    //     .replace(/[^a-zA-Z0-9]/g, '');
    // }
    // // 输入邮箱
    // formatEmail(field: string) {
    //   // (this.form[field as keyof PortraitAddRequest] as string) = this.form[field as keyof PortraitAddRequest]
    //   //   .toString()
    //   //   .replace(/[^a-zA-Z0-9]/g, '');
    //   // TODO 确认校验输入字符
    //   console.log(field);
    // }
    // // 输入默认
    // formatDefault(field: string) {
    //   (this.form[field as keyof PortraitAddRequest] as string) = this.form[field as keyof PortraitAddRequest]
    //     .toString()
    //     .replace(/[^\u4e00-\u9fa5_a-zA-Z0-9_]/g, '');
    // }
    handleCancel() {
        this.$router.back();
    }
    handleEdit(item) {
        const query = this.$route.query;
        this.$router.replace({
            name: 'bodyCreate',
            query: { ...query, type: PageQueryTypeEnum.EDIT, id: item.portraitBodyId?.toString() },
        });
        this.isDetail = false;
        if (this.$route.meta && this.$route.meta.breadcrumbs) {
            let breadcrumbs = this.$route.meta.breadcrumbs;
            let lastBreadcrumb = breadcrumbs[breadcrumbs.length - 1];
            if (lastBreadcrumb.meta)
                lastBreadcrumb.meta.title = bodyCreateI18nKey[PageQueryTypeEnum.EDIT];
        }
    }
    handleSubmit() {
        if (this.form.validateType === this.custom && !this.form.validateEndDate)
            return this.$elmessage.warning(this.$t('pleaseSelectExpirationDate').toString());
        const query = this.$route.query;
        this.$refs['form'].validate((valid) => {
            if (valid) {
                if (query.type === PageQueryTypeEnum.CREATE) {
                    let form = {
                        ...this.form,
                        libIds: [+query.libId],
                    };
                    this.addBody(form);
                }
                else if (query.type === PageQueryTypeEnum.EDIT) {
                    let form = {
                        ...this.form,
                        libIds: [+query.libId],
                    };
                    this.updateBody(form);
                }
            }
            else {
                console.log('validate error !');
                return false;
            }
        });
    }
    async addBody(form) {
        if (this.submiting)
            return;
        this.submiting = true;
        try {
            await Webapi.addBody(form);
            this.$message({
                customClass: 'success-message',
                message: this.$t('createSuccessfully').toString(),
                type: 'success',
                showClose: true,
            });
            this.$router.back();
        }
        catch (error) { }
        this.submiting = false;
    }
    async updateBody(form) {
        if (this.submiting)
            return;
        this.submiting = true;
        try {
            await Webapi.updateBody(form);
            this.$message({
                customClass: 'success-message',
                message: this.$t('editSuccessfully').toString(),
                type: 'success',
                showClose: true,
            });
            this.$router.back();
        }
        catch (error) { }
        this.submiting = false;
    }
};
__decorate([
    Watch('form.validateType', { immediate: true, deep: true })
], default_1.prototype, "validateType", null);
default_1 = __decorate([
    Component({
        i18n: {
            messages: {
                en: {
                    ...lang.en,
                    body: 'Body',
                    nameInputPlaceholder: 'Please enter name',
                    nationalityInputPlaceholder: 'Please enter nationality',
                    birthdateInputPlaceholder: 'Please select date of birth',
                    telephoneInputPlaceholder: 'Please enter telephone',
                    emailInputPlaceholder: 'Please enter email',
                    departmentInputPlaceholder: 'Please enter department,  such as xxx/xxx',
                    entryTimeInputPlaceholder: 'Please select entry time',
                    identityNumberInputPlaceholder: 'Please enter Identity Number',
                    employeeIDInputPlaceholder: 'Please enter employee ID',
                    passIDInputPlaceholder: 'Please enter pass ID',
                    icCardNumberInputPlaceholder: 'Please enter IC card number',
                    noteInputPlaceholder: 'Please enter note',
                    imageInputPlaceholder: 'Upload at least one picture',
                    emailRulePlaceholder: 'Please enter the correct email address',
                },
                zh: {
                    ...lang.zh,
                    body: '人体',
                    nameInputPlaceholder: '请输入名称',
                    nationalityInputPlaceholder: '请输入国籍',
                    birthdateInputPlaceholder: '请选择出生日期',
                    telephoneInputPlaceholder: '请输入电话',
                    emailInputPlaceholder: '请输入电子邮箱',
                    departmentInputPlaceholder: '请输入部门，例如xxx/xxx',
                    entryTimeInputPlaceholder: '请选择入职时间',
                    identityNumberInputPlaceholder: '请输入身份号码',
                    employeeIDInputPlaceholder: '请输入员工ID',
                    passIDInputPlaceholder: '请输入通行证ID',
                    icCardNumberInputPlaceholder: '请输入IC卡号码',
                    noteInputPlaceholder: '请输入备注',
                    imageInputPlaceholder: '至少上传一张图片',
                    emailRulePlaceholder: '请输入正确的邮箱地址',
                },
            },
        },
        components: {
            UploadPicture,
        },
    })
], default_1);
export default default_1;
